import React from "react";
import PropTypes from "prop-types";
import "../../styles/studio/studio.css";

export default function StudioShell({
  mode = "standalone",
  header = null,
  explorer = null,
  canvas = null,
  inspector = null,
  assets = null,
  statusBar = null,
}) {
  const workspaceClassName = [
    "studio-framework-workspace",
    explorer ? "studio-framework-workspace--with-explorer" : "",
    inspector ? "studio-framework-workspace--with-inspector" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={`studio-framework-shell studio-framework-shell--${mode}`}>
      {header && (
        <header className="studio-framework-header">
          {header}
        </header>
      )}

      <div className={workspaceClassName}>
        {explorer && (
          <aside className="studio-framework-explorer">
            {explorer}
          </aside>
        )}

        <main className="studio-framework-canvas">
          {canvas}
        </main>

        {inspector && (
          <aside className="studio-framework-inspector">
            {inspector}
          </aside>
        )}
      </div>

      {assets && (
        <footer className="studio-framework-assets">
          {assets}
        </footer>
      )}

      {statusBar && (
        <div className="studio-framework-statusbar">
          {statusBar}
        </div>
      )}
    </section>
  );
}

StudioShell.propTypes = {
  mode: PropTypes.oneOf(["standalone", "embedded", "fullscreen"]),
  header: PropTypes.node,
  explorer: PropTypes.node,
  canvas: PropTypes.node,
  inspector: PropTypes.node,
  assets: PropTypes.node,
  statusBar: PropTypes.node,
};
